import script from "./AppCookieAccordion.vue?vue&type=script&setup=true&lang=js"
export * from "./AppCookieAccordion.vue?vue&type=script&setup=true&lang=js"

import "./AppCookieAccordion.vue?vue&type=style&index=0&id=61f2f3d5&lang=scss&scoped=true"

import exportComponent from "/home/nodejs/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61f2f3d5"]])

export default __exports__